import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';
import { find } from 'lodash';
import ReactBodymovin from 'react-bodymovin'
import animation from './animation.json'
import Fade from 'react-reveal/Fade';

// import { data } from './data'
import { fetchPage, getPages } from '../Page/redux';

import { LetterLinks } from '../../components'

import { media } from '../../styles/utils';
import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding } from '../../styles/global';
import { isClient } from '../../utils.js';
import MetaTags from '../../components/MetaTags/MetaTags.js';


class Home extends Component {

    state = {

    }

    componentWillMount = () => {
        this.props.fetchPage('home');
    }

    render() {
        const { pages } = this.props;
        const pageData = find(pages, (o) => { return o.slug === 'home' })

        return (
            <Container>
                {pageData && (
                    <Intro>

                        <MetaTags       
                            noPrefix={true}
                            title={'UIOLI'}
                            description={pageData.text}
                        />

                       <Logo>
                            <ReactBodymovin 
                                options={{
                                    loop: true,
                                    autoplay: true,
                                    prerender: true,
                                    animationData: animation
                                }} 
                            />
                       </Logo>

                        <Fade 
                            up
                            duration={1000}
                            distance={'50px'}
                            appear={true}
                        >
                            <IntroText
                                dangerouslySetInnerHTML={{__html: pageData.text}}
                            />
                        </Fade>
                    </Intro>
                )}

                {pageData && (
                    <LetterLinks/>
                )}
            </Container>
        )
    }
}

const Container = styled.div`
    background: white;
    min-height: 100vh;
`;

const Intro = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;   
    align-items: center; 
    padding-top: 132px;
`;

const Logo = styled.div`
    width: 240px;
    height: 240px;
    margin-bottom: 115px;
`

const IntroText = styled.div`
    max-width: 740px;
    margin-bottom: 128px;
    text-align: center;
    
    p {
        ${body}
    }
    
    ${padding}
`;



const mapDispatchToProps = dispatch => ({
    fetchPage(slug) {
        dispatch(fetchPage(slug))
    }
})

const mapStateToProps = (state, props) => ({
    pages: getPages(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./client/modules/Home/Home.js